import React, { HTMLAttributes } from 'react';
import IconButton from '#/components/Form/IconButton/IconButton';

interface IProperties {
  onClick?: HTMLAttributes<HTMLButtonElement>['onClick'];
}

const AlbumsPlayButton = ({ onClick }: IProperties) => {
  return (
    <IconButton
      className=" p-1 bg-theme-white text-theme-black outline-offset-[-1px] outline-none hover:outline-theme-white hover:outline"
      iconClassName=" text-[1.5rem]"
      icon="play_arrow"
      onClick={onClick}
    />
  );
};

export default AlbumsPlayButton;
